import { orchestrator } from "satcheljs";
import openPreviewPage from "../actions/openPreviewPage";
import { IPreviewSchedulePageStore } from "../store/PreviewSchedulePageStore";
import { setIsPreviewSchedulePageOpen, setSelectedTagId, setStartAndEndDate, setSelectedJobId, setGenerateOption } from "../mutators/uiMutators";
import initializePreviewSchedulePageStates from "../actions/initializePreviewSchedulePageStates";
import { updateIsDataInDateRangeLoaded } from "../../schedules/lib";
import { GenerateOptions } from "../../smartSchedule/smartScheduleUtils";
import setGlobalMessage from "../../../actions/setGlobalMessage";
import { appViewState } from "../../../store";

export const openPreviewPageOrchestrator = orchestrator(
    openPreviewPage,
    (actionMessage: {
        viewState: IPreviewSchedulePageStore,
        open: boolean,
        selectedTagId?: string,
        startDate?: string,
        endDate?: string,
        jobId: string,
        generateOption?: GenerateOptions
    }) => {
        const { viewState, selectedTagId, open, startDate, endDate, jobId, generateOption } = actionMessage;
        if (open) {
             // Clear any existing global messages (like smart scheduling banners)
            setGlobalMessage(
                appViewState().globalMessageViewState,
                null,
                undefined,
                null,
                null,
                false,
                false,
                null,
                0,
                false,
                undefined,
                null
            );
            // Set selected tag ID
            setSelectedTagId(selectedTagId);

            // Set start and end date based on polling response
            setStartAndEndDate(startDate, endDate);

            setGenerateOption(generateOption);
            // Fetch data and populate view state
            initializePreviewSchedulePageStates(viewState);

            // Open the page
            setIsPreviewSchedulePageOpen(true);

            setSelectedJobId(jobId);
        } else {
            setSelectedTagId(null);

            // reset data loaded state
            updateIsDataInDateRangeLoaded(false, viewState);

            // Close the page
            setIsPreviewSchedulePageOpen(false);
        }

    }
);